import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { Home } from "lucide-react";

export const IndustrialHeader = () => {
  const { language, setLanguage } = useLanguage();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-3 md:py-4">
        <div className="flex items-center justify-between">
          {/* Logo - Left */}
          <div
            className="flex items-center space-x-1 font-bold text-lg sm:text-xl md:text-2xl pl-1
                       tracking-[0.18em] sm:tracking-[0.24em] md:tracking-[0.3em]"
            style={{ fontFamily: "var(--font-eurostile)", fontWeight: "900" }}
          >
            <span className="tracking-[-0.12em] text-white">E</span>
            <span className="tracking-[-0.20em] text-white">Y</span>
            <span className="text-[#5a6e54]">A</span>
          </div>

          {/* Home Icon - Center */}
          <button
            onClick={scrollToTop}
            className="flex items-center justify-center w-8 h-8 hover:opacity-70 transition-opacity duration-200"
            title="Home"
          >
            <Home size={20} className="text-[#5a6e54]" />
          </button>

          {/* Language Switcher - Right */}
          <div className="flex items-center gap-2 sm:gap-3">
            <button
              onClick={() => setLanguage("en")}
              className={`transition-all duration-200 ${
                language === "en"
                  ? "opacity-100 scale-110"
                  : "opacity-50 hover:opacity-75"
              }`}
              title="English"
            >
              <svg
                className="w-6 h-4 sm:w-7 sm:h-5"
                viewBox="0 0 28 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="28" height="20" fill="#012169" />
                <path d="M0 0L28 20M28 0L0 20" stroke="white" strokeWidth="3" />
                <path d="M0 0L28 20M28 0L0 20" stroke="#C8102E" strokeWidth="2" />
                <path d="M14 0V20M0 10H28" stroke="white" strokeWidth="5" />
                <path d="M14 0V20M0 10H28" stroke="#C8102E" strokeWidth="3" />
              </svg>
            </button>

            <button
              onClick={() => setLanguage("fr")}
              className={`transition-all duration-200 ${
                language === "fr"
                  ? "opacity-100 scale-110"
                  : "opacity-50 hover:opacity-75"
              }`}
              title="Français"
            >
              <svg
                className="w-6 h-4 sm:w-7 sm:h-5"
                viewBox="0 0 28 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="9.33" height="20" fill="#002395" />
                <rect x="9.33" width="9.33" height="20" fill="white" />
                <rect x="18.66" width="9.34" height="20" fill="#ED2939" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
